import React from 'react';


import HomeIcon from "../assets/figshelf/Home";
import MessagesIcon from "../assets/figshelf/Chat";
import DatabaseIcon from "../assets/figshelf/Database";
import MarketplaceIcon from "../assets/figshelf/Marketplace";
import UsersIcon from "../assets/figshelf/Users";
import BookmarkIcon from "../assets/figshelf/Bookmark";
import NotificationIcon from "../assets/figshelf/Notification";
import HeartIcon from "../assets/figshelf/Heart";
import CommentIcon from "../assets/figshelf/Comment";
import ShareIcon from "../assets/figshelf/Share";
import Wiki from '../assets/figshelf/Wiki';
import GroupsIcon from '../assets/figshelf/Groups';
import RankingIcon from '../assets/figshelf/Ranking';


const ICONS = {
  home: HomeIcon,
  messages: MessagesIcon,
  database: DatabaseIcon,
  marketplace: MarketplaceIcon,
  profile: UsersIcon,
  bookmark: BookmarkIcon,
  wiki: Wiki,
  notification: NotificationIcon,
  heart: HeartIcon,
  comment: CommentIcon,
  share: ShareIcon,
  groups: GroupsIcon,
  ranking: RankingIcon,
};

const Icon = ({ name, size = 22, color = 'currentColor', sx = {} }) => {
  const Fallback = ICONS[name];

  if (!Fallback) {
    return null;
  }

  return (
    <span style={{ display: 'inline-flex', lineHeight: 0 }}>
      <Fallback size={size} color={color} sx={sx} />
    </span>
  );
};

export default Icon;
